/*
 * @Author: zhouwei
 * @Date: 2019-11-18 15:22:09
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-07-09 16:41:09
 * @Desc: 我的推广页面
*/
<template>
  <div class="my-promotion">
    <div class="header">
      <h3>账户余额：￥{{ account.toFixed(2) }}</h3>
      <div
        class="explain"
        @click="showExplain"
      >
        <mk-iconfont
          class="icon"
          icon-class="wenhao"
        ></mk-iconfont>
        <span>充值说明</span>
      </div>
    </div>
    <div class="select">
      <div class="select-content">
        <mk-input
          v-model="title"
          class="select-item"
          width="240"
          placeholder="推广内容名称"
          clearable
          @clear="search"
          @keyup.enter.native="search"
        >
          <div
            slot="suffix"
            class="el-input__icon"
          >
            <i
              class="el-icon-search"
              @click="search"
            />
          </div>
        </mk-input>
        <mk-select
          v-model="activeIndex"
          class="select-item"
          width="160"
        >
          <mk-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <div class="btn-group">
          <mk-button-biz
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz @click="reset">
            重置
          </mk-button-biz>
        </div>
      </div>
      <mk-button-biz
        type="primary"
        icon="el-icon-plus"
        width="128px"
        @click="addPromotion"
      >
        创建推广
      </mk-button-biz>
    </div>

    <div class="list">
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="list"
      >
        <mk-table-column
          prop="title"
          label="推广内容"
          min-width="250"
          fixed
        >
          <template v-slot="scope">
            <mk-tooltip
              class="item"
              effect="light"
              content="点击预览"
              placement="right"
            >
              <span
                class="ellipsis"
                style="color:#009cff; cursor: pointer;"
                @click="showPreviewArticle(scope.row)"
              >
                《{{ scope.row.title }}》
              </span>
            </mk-tooltip>
          </template>
        </mk-table-column>
        <mk-table-column
          label="推广日期"
          width="200"
        >
          <template v-slot="scope">
            {{ handleStr(scope.row.startTime) }} ~ {{ handleStr(scope.row.endTime) }}
          </template>
        </mk-table-column>
        <mk-table-column
          label="状态"
          width="150"
        >
          <template v-slot="scope">
            <div class="status-group">
              <span
                class="status-icon"
                :class="'status' + scope.row.status"
              ></span>
              {{ getStatusName(scope.row.status) }}
              <mk-popover
                v-if="scope.row.status === 2"
                placement="right-start"
                trigger="hover"
                :content="scope.row.rejectReason"
              >
                <mk-iconfont
                  slot="reference"
                  class="status-info"
                  icon-class="wenhao"
                ></mk-iconfont>
              </mk-popover>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          label="预算使用情况"
          min-width="250"
        >
          <template v-slot="scope">
            <div class="budget">
              <template v-if="scope.row.budGet">
                <span class="info">总预算金额: {{ scope.row.budGet }}元，已使用{{ getPercent(scope.row.budGet,scope.row.consume) + '%' }}</span>
                <mk-progress
                  class="progress"
                  :percentage="getPercent(scope.row.budGet,scope.row.consume) >= 100 ? 100 : (getPercent(scope.row.budGet,scope.row.consume)|| 0)"
                  :show-text="false"
                ></mk-progress>
              </template>
              <template v-else>
                \
              </template>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          label="操作"
          width="120"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              size="small"
              @click="handClick('detail',scope.row)"
            >
              详情
            </mk-button-biz>
            <mk-button-biz
              v-if="scope.row.status === 2"
              type="text"
              size="small"
              @click="handClick('resubmit',scope.row)"
            >
              重新提交
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <explain
      :show="show"
      @cancel="cancel"
    ></explain>
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
    <preview
      :id="articleId"
      :key="articleId"
      :show="showArticle"
      :title="articleTitle"
      @cancel="cancelShow"
    ></preview>
  </div>
</template>
<script>
import explain from './explain.vue'
import preview from '../preview/index.vue'
import { PROMOTIONAPIS } from '@api'
export default {
  components: {
    explain,
    preview
  },
  data () {
    return {
      tableMaxHeight: 0,
      articleId: '',
      account: 0,
      show: false,
      showArticle: false,
      articleTitle: '',
      options: [
        {
          label: '全部状态',
          value: 0
        },
        {
          label: '待审核',
          value: 1
        },
        {
          label: '审核未通过',
          value: 2
        },
        {
          label: '进行中',
          value: 3
        },
        {
          label: '已结束',
          value: 4
        }
      ],
      activeIndex: 0,
      title: '',
      list: [],
      page: 1,
      total: 0
    }
  },
  created () {
    this.getList()
    this.getAccount()
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.list', this)
    })
  },
  methods: {
    async getAccount () {
      const res = await PROMOTIONAPIS.AccountApi.accountBalanceGet()
      if (res.success) {
        this.account = Number(res.data)
      }
    },
    async getList () {
      let metas = {
        page: this.page,
        status: this.activeIndex,
        title: this.title
      }
      if (!this.activeIndex) {
        delete metas['status']
      }
      if (!this.title) {
        delete metas['title']
      }
      const res = await PROMOTIONAPIS.ContentApi.contentListPost(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    getStatusName (status) {
      let statusArr = ['全部状态', '待审核', '审核未通过', '进行中', '已结束']
      return statusArr[status]
    },
    getPercent (total, used) {
      return Number(((used * 100) / total).toFixed(2))
    },
    showExplain () {
      this.show = true
    },
    showPreviewArticle (data) {
      this.articleTitle = data.title
      this.articleId = data._id
      this.showArticle = true
    },
    cancel () {
      this.show = false
    },
    cancelShow () {
      this.showArticle = false
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    search () {
      this.page = 1
      this.getList()
    },
    reset () {
      this.activeIndex = 0
      this.title = ''
      this.search()
    },
    addPromotion () {
      // 创建推广
      this.$router.push({
        path: '/promotion/my-promotion/add',
        query: {
          account: this.account
        }
      })
    },
    handClick (type, data) {
      if (type === 'detail') {
        let isEnd = false
        data.status === 4 ? (isEnd = true) : (isEnd = false)
        this.$router.push({
          path: '/promotion/my-promotion/detail',
          query: {
            id: data._id,
            isEnd: isEnd
          }
        })
      } else if (type === 'resubmit') {
        this.$router.push({
          path: '/promotion/my-promotion/add',
          query: {
            reset: 1,
            account: this.account,
            id: data._id
          }
        })
      }
    },
    handleStr (str) {
      if (str && str.indexOf(' ') > 0) {
        return str.split(' ')[0]
      } else {
        return str
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.my-promotion {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  & /deep/ .el-input__inner {
    padding-right: 50px;
  }

  & /deep/ .el-input__suffix {
    .el-input__clear {
      position: absolute;
      top: 0;
      left: -25px;
    }
  }

  .header {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    box-shadow: 0 -1px 0 0 #e8e8e8 inset;

    h3 {
      font-size: 16px;
    }

    .explain {
      margin-left: 16px;
      cursor: pointer;

      span {
        color: #888;
        font-size: 14px;
      }

      .icon {
        font-size: 14px;
        color: #d9d9d9;
        margin-right: 4px;
      }
    }
  }

  .select {
    display: flex;
    margin: 20px;
    justify-content: space-between;

    .select-content {
      display: flex;

      .select-item {
        margin-right: 20px;
      }
    }
  }

  .list {
    flex: 1;
    width: calc(100% - 40px);
    margin: 0 auto;

    .budget {
      .info {
        font-size: 13px;
      }

      .progress {
        width: 68%;
        margin-top: 4px;
      }
    }

    .status-info {
      color: #ccc;
      font-size: 13px;
      cursor: pointer;
      margin-left: 4px;
    }
  }

  .status-group {
    display: flex;
    color: #595959;
    font-size: 13px;
    align-items: center;

    .status-icon {
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 8px;
    }

    .status1,
    .status4 {
      background-color: #bfbfbf;
    }

    .status2 {
      background-color: #ff6b6b;
    }

    .status3 {
      background-color: #009cff;
    }
  }

  .pagination {
    margin-bottom: 20px;
  }
}
</style>
